import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../components/shared/services/auth.service';
import { canUseSage } from '../shared/services/sage-integration.model';

@Injectable({
  providedIn: 'root'
})
export class SageAccessGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (canUseSage(this.authService.getUserRole())) {
      return true;
    }

    this.router.navigate(['/dashboard']);
    return false;
  }
}
